import { SET_DEALER_ACCESSORIES } from '../actions/types';

export default function accessories(state = [], action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_DEALER_ACCESSORIES:
				return action.payload;

			// no default
		}
	}

	return state;
}
